import { useEffect } from 'react';
import { posthog } from './posthog';
import { useAuth } from '@shared/auth';
import { env } from '../../env';

export function usePostHogIdentify() {
  const { status, session } = useAuth();

  useEffect(() => {
    if (!env.POSTHOG_KEY) return;

    if (status === 'authenticated' && session?.user) {
      posthog.identify(session.user.id, {
        email: session.user.email,
        name: session.user.name,
      });

      if (session.org) {
        posthog.group('organization', session.org.id, {
          name: session.org.name,
        });
      }
    }

    if (status === 'unauthenticated') {
      posthog.reset();
    }
  }, [status, session?.user?.id, session?.org?.id]);
}
